import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import SelectDeliveryArea from "components/outlet-based-areas/SelectDeliveryArea";
import { BrandAction } from "store/actions";
import ChangeDeliveringToModalContainer from "./ChangeDeliveringToModalContainer";
import PreOrderingSlotWidget from "components/Pre-ordering/PreOrderingSlotWidget";

import C from "Constants";
import { useCustomHistory } from "hooks";
import { getStoreAreaName } from "utils/storeUtils";
import useGetSavedAddressList from "service-hooks/useGetSavedAddressList";
import SlideInLayout from "components/layouts/SlideInLayout";
import SelectedLocation from "./SelectedLocation";

function DeliveringTo({ selectedArea, lang }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const params = useParams();
  const router = useCustomHistory();

  const { brandInfo } = useSelector((state) => state?.brandStorageReducer);
  const [isChngeAreaModalopen, setChngeAreaModalopen] = useState(false);
  const [isContainerModalopen, setContainerModalopen] = useState(false);
  const { shippingMethod, DomainType } = useSelector(
    (state) => state?.AppReducer
  );
  const { selectedStore } = useSelector((state) => state?.store);
  const { orderTiming } = useSelector((state) => state?.orderTimingReducer);

  const [isPreOrderingSlotWidget, setPreOrderingSlotWidget] = useState(false);

  const handleChangeOrderStore = () => {
    if (shippingMethod === C.SHIPPING_METHODS.MAPPED_AREA_BASED) {
      router(
        "/address/select-delivery-area",
        `/${params.domainName}/address/select-delivery-area`,
        DomainType
      );
      return;
    }
    dispatch(
      BrandAction.getBrandDeliveryAreas({
        brandId: brandInfo?.brand?._id,
        updateMethod: true,
      })
    );
    setChngeAreaModalopen(true);
  };

  const { getAddresses } = useGetSavedAddressList({
    fetch: false,
    type: "filtered",
  });
  const fetchUserAddresses = () => {
    getAddresses(null, "all");
    setContainerModalopen(true);
  };

  return (
    <>
     
        <SelectedLocation
          storeName={getStoreAreaName(lang, shippingMethod, selectedArea)}
          orderTiming={orderTiming}
          title={t("Delivering to")}
          onClick={fetchUserAddresses}
        />

      <ChangeDeliveringToModalContainer
        isContainerModalopen={isContainerModalopen}
        setContainerModalopen={setContainerModalopen}
        handleChangeOrderStore={handleChangeOrderStore}
        setPreOrderingSlotWidget={setPreOrderingSlotWidget}
        setChngeAreaModalopen={setChngeAreaModalopen}
        preORderSlots={selectedStore?.availablePreOrderSlotsForDelivery}
        isPreORderEnabled={selectedStore?.isPreOrderEnabledForDelivery}
      />

      <SlideInLayout
        shouldCloseOnEsc="No"
        shouldCloseOnOverlayClick="No"
        open={isChngeAreaModalopen}
        handleClose={() => setChngeAreaModalopen(false)}
        container={{
          className: `py-2 h-5 min-h-70p `,
        }}
        styleClasses="h-full"
      >
        <SelectDeliveryArea
          header={false}
          headerLabel=""

        />
      </SlideInLayout>

       <PreOrderingSlotWidget
        selectedStore={selectedStore}
        isPreOrderingSlotWidget={isPreOrderingSlotWidget}
        setPreOrderingSlotWidget={setPreOrderingSlotWidget}
      /> 
    </>
  );
}

export default DeliveringTo;
